export default "__VITE_ASSET__CYKbYWc3__"